var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "slider" }, [
    _c("div", { ref: "fakeTainer", staticClass: "container" }),
    _vm._v(" "),
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "slider" },
          _vm._l(_vm.renderedImages, function (image, key) {
            return _c("img", {
              key: key,
              class: `image-${key}`,
              style: {
                width: `${image.preffered_width}px`,
                height: `${image.preffered_height}px`,
              },
              attrs: { src: image.src },
            })
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }